import {Component, OnInit, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MOVE_ASSET_BACK_TO_OPPORTUNITY, MOVE_ASSET_INTO_HOLDING_PEN, MOVE_ASSET_INTO_OTHER_OPPORTUNITY ,
  MOVE_ASSET_INTO_OTHER_CONTRACT, MOVE_ASSET_BACK_TO_WIP, Asset, RETURN_TO_PREVIOUS_SALE, MOVE_ASSET_INTO_AUCTION_EVENT,
  RBA_LIVE, ASSET_STATUS_BUYER_ABANDONED, RESELL_ASSET
} from '../../shared/domain/item';
import {
  ASSET_STATUS_COLLAPSED_TO_INVENTORY,
  ASSET_STATUS_COLLAPSED_TO_SELLER,
  ASSET_STATUS_SOLD, ASSET_STATUS_LOT_PULLED
} from '../../shared/domain/item';
import {AuditAssetMove} from '../../shared/domain/item';
import {ContractType} from "../../shared/domain/contract";
import {ItemSummaryItemService} from "../../shared/asset";
import {Opportunity} from "../../shared/domain/opportunity";

@Component({
  selector: 'lib-item-summary-move-assets',
  templateUrl: './move-assets.component.html',
  styleUrls: ['./move-assets.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MoveAssetsComponent implements OnInit {

  public auditAssetMove: AuditAssetMove = new AuditAssetMove();
  public contractId;
  public assets: Asset[] = [];

  private hasSoldOrCollapsedItems = false;
  private hasLotPulledAssets = false;
  private loadMoveReason = false;
  private isAuctionEventContract = false;
  private isExhibitAOrInventoryAssetContract: boolean;

  public resellType: string;
  public step1Ready : boolean;
  public displayResellButton : boolean;
  public collapseItem : boolean;
  public abandonItem: boolean;
  public reconsignItem: boolean;
  public isAuctionEventActive: boolean;
  public isEventEndedMoreThan30DaysAgo: boolean;
  public isEventEndedMoreThan120DaysAgo: boolean;
  public canMoveSoldIPAsset: boolean;
  public canMoveSoldRBAsset: boolean;

  public RESELL_ASSET = RESELL_ASSET;
  public COLLAPSE_TO_RB_DESCRIPTION = 'Collapse to RB';
  public RESELL_ABANDONED_DESCRIPTION = 'Resell Abandoned Item';
  public RECONSIGN_DESCRIPTION = 'Reconsign Item';

  public itemService: ItemSummaryItemService;
  public opportunity: Opportunity;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
    this.contractId = this.data.contractId;
    this.assets = this.data.selectedAssets;
    this.itemService = this.data.itemSummaryItemService;
    this.opportunity = this.data.opportunity;
    this.isAuctionEventActive = this.data.isAuctionEventActive;
    this.isEventEndedMoreThan30DaysAgo = this.data.eventEndedMoreThan30DaysAgo;
    this.isEventEndedMoreThan120DaysAgo = this.data.eventEndedMoreThan120DaysAgo;
    this.canMoveSoldIPAsset = this.data.canMoveSoldIPAsset;
    this.canMoveSoldRBAsset = this.data.canMoveSoldRBAsset;
  }

  ngOnInit() {
    this.assets.forEach(asset => {
      if ( asset.assetStatusId === ASSET_STATUS_SOLD || asset.assetStatusId === ASSET_STATUS_COLLAPSED_TO_INVENTORY ||
         asset.assetStatusId === ASSET_STATUS_COLLAPSED_TO_SELLER) {
        this.hasSoldOrCollapsedItems = true;
      }

      if ( asset.assetStatusId === ASSET_STATUS_LOT_PULLED ){
        this.hasLotPulledAssets = true;
      }
      this.isExhibitAOrInventoryAssetContract = ContractType.isAuctionEventContract(asset.contractRecordType);
    });

    this.step1Ready = this.assets && this.assets.length > 0;
    this.loadResellOption();
  }

  public isSaleInfoStepVisible(): boolean {
    let displaySaleInfoStep = true;
    if (this.auditAssetMove.destinationType === MOVE_ASSET_BACK_TO_OPPORTUNITY) {
      displaySaleInfoStep = false;
    } else if ( this.auditAssetMove.destinationType === MOVE_ASSET_INTO_HOLDING_PEN ) {
      displaySaleInfoStep = false;
    } else if ( this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_CONTRACT && this.hasSoldOrCollapsedItems ) {
      displaySaleInfoStep = false;
    } else if (this.auditAssetMove.destinationType === MOVE_ASSET_BACK_TO_WIP) {
      displaySaleInfoStep = false;
    } else if(this.auditAssetMove.destinationType === RETURN_TO_PREVIOUS_SALE){
      displaySaleInfoStep = false;
    } else if (this.isAuctionEventContract) {
      displaySaleInfoStep = false;
    }
    return displaySaleInfoStep;
  }

  public reloadAssets(assets): void {
    this.assets = assets;
  }

  public isLoadSaleInfoComponent(): boolean {
    if (!this.auditAssetMove.destinationType) {
      return false;
    } else if (this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_OPPORTUNITY && !this.auditAssetMove.selectedOpportunity) {
      return false;
    } else if (this.isExhibitAOrInventoryAssetContract && this.auditAssetMove.destinationType === MOVE_ASSET_INTO_AUCTION_EVENT && !this.auditAssetMove.selectedContract) {
      return false;
    } else if (this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_CONTRACT && !this.auditAssetMove.selectedContract) {
      return false;
    } else {
      return true;
    }
  }

  public isLoadMoveReasonComponent(): boolean {
    return !!this.auditAssetMove.destinationType && ( this.loadMoveReason || !this.isSaleInfoStepVisible() );
  }

  public loadMoveReasonComponent(assets: Asset[]): void {
    this.assets = assets;
    this.loadMoveReason = true;
  }

  public isAuctionEventContractSelected(isAuctionEventContract: boolean): void {
    this.isAuctionEventContract = isAuctionEventContract;
  }

  public loadResellOption(): void {
    if (this.assets) {
      this.displayResellButton =  this.isCollapsedItem() || this.isAbandonedItem() || this.isReconsignedItem();
      this.resellType =  this.collapseItem ? this.COLLAPSE_TO_RB_DESCRIPTION : this.abandonItem ? this.RESELL_ABANDONED_DESCRIPTION : this.reconsignItem ? this.RECONSIGN_DESCRIPTION : '';
    }
  }

  private isCollapsedItem() : boolean {
    this.collapseItem = !this.assets.some(selectedAsset => selectedAsset.assetStatusId !== ASSET_STATUS_COLLAPSED_TO_INVENTORY || selectedAsset.saleType !== RBA_LIVE);
    return this.collapseItem;
  }

  private isAbandonedItem() : boolean {
    this.abandonItem = !this.assets.some(selectedAsset => selectedAsset.assetStatusId !== ASSET_STATUS_BUYER_ABANDONED);
    return this.abandonItem;
  }

  private isReconsignedItem() : boolean {
    this.reconsignItem = !this.assets.some(selectedAsset => (selectedAsset.assetStatusId !== ASSET_STATUS_SOLD || selectedAsset.saleType !== RBA_LIVE)) && this.isAuctionEventActive;
    return this.reconsignItem;
  }

}
